import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { apiPHP } from '../../services/api';
import Base from './base';
import GameContextProvider from './context/GameContext';
/* Interfaces & API */
import { getGameSaved, getGameTemplate, iState } from './context/interfaces';
/* Functions*/
import getPossibleClue from './utils/getPossibleClue';
import initializeHousesStates from './utils/initializeHousesStates';
import setSubFocus from './utils/setSubFocus';

interface GameDetail {
  titulo: string;
  estilos_de_passatempos_id: number;
  texto: string;
}

export const CrossWords: React.FC = () => {
  // let id = 27;

  const params = useParams();
  const id = Number(params.id);

  const [INITIAL_STATE, setInitialState] = useState<iState>();
  const [loading, setLoading] = useState<boolean>(true);
  const [size, setSize] = useState<number>(0);
  const [sizeHeight, setSizeHeight] = useState(0);
  const [direct, setDirect] = useState(false);
  const [gameDetail, setGameDetail] = useState<GameDetail>({} as GameDetail);

  const initializeGame = async () => {
    try {
      //get game details from api
      const { data } = await apiPHP.get(`/passatempos/${id}`);

      setGameDetail(data[0]);
      console.log(data[0]);
      if (data[0].estilos_de_passatempos_id === 5) {
        setDirect(true);
      }

      const template = await getGameTemplate(id);
      // Object.keys(template.chaves.horizontal).forEach(function(item){
      //   console.log(item + " = " + template.chaves.horizontal[item][0].chave);
      //  });

      if (template.matrix[0]) setSize(template?.matrix[0]?.length);
      setSizeHeight(template?.matrix.length);
      //const details = await getGameDetails(gameID);
      // console.log(Object.getOwnPropertyNames(template.chaves.horizontal).sort());
      // console.log("Primeiro", Object.keys(template.chaves.horizontal)[0]);
      // console.log("Last", Object.keys(template.chaves.horizontal)[Object.keys(template.chaves.horizontal).length-1]);
      const [firstClueNumberHorizontal, lastClueNumberHorizontal] = [
        parseInt(Object.keys(template.chaves.horizontal)[0]),
        parseInt(
          Object.keys(template.chaves.horizontal)[
          Object.keys(template.chaves.horizontal).length - 1
          ]
        ),
      ];
      const [firstClueNumberVertical, lastClueNumberVertical] = [
        parseInt(Object.keys(template.chaves.vertical)[0]),
        parseInt(
          Object.keys(template.chaves.vertical)[
          Object.keys(template.chaves.vertical).length - 1
          ]
        ),
      ];

      var saved = await getGameSaved(id);

        const matrix = template.matrix.map((row, rowIndex) => {
          return row.map((col, colIndex) => {
            return {
              numero: col.numero,
              letra: '',
              palavraHorizontal: col.palavra_horizontal,
              palavraVertical: col.palavra_vertical,
            };
          });
        });
        var progress = {
          tempo: 0,
          pontuacao: 0,
          matrix: matrix,
        };
        await apiPHP
          .post(`/passatempos/${params.id}/progresso`, progress)
          .catch((err) => {
            throw err;
          });

        saved = await getGameSaved(id);

      // A FUNÇÃO DE BAIXO ESTÁ DANDO ERRO EM ALGUNS IDS, COMO O 27
      const firstPossibleClue = getPossibleClue(saved?.cache?.matrix, template);
      ///draft.howManyCluesVertical = Object.keys(allCluesVertical).length;
      //console.log("firstPossibleClue", firstPossibleClue);
      var response = initializeHousesStates(template, saved);
      var { houseStates, maxScore } = response;
      var subFocusResult = setSubFocus({
        selectedClue: firstPossibleClue.clueNumber,
        orientation: firstPossibleClue.orientation,
        focusedHouse: firstPossibleClue.focusedHouse,
        houseStates,
      });
      const state: iState = {
        GameTemplate: template,
        GameState: {
          currentClueNumber: firstPossibleClue.clueNumber,
          currentClueText: firstPossibleClue.clueText,
          orientation: firstPossibleClue.orientation,
          cluesInfos: {
            firstClueNumberHorizontal,
            lastClueNumberHorizontal,
            firstClueNumberVertical,
            lastClueNumberVertical,
          },
          focusedHouse: subFocusResult.focusedHouse,
          finished: false,
          completed: false,
          score: saved.cache.pontuacao ?? 0,
          time: saved.cache.tempo,
          savedGame: saved,
          maxScore: maxScore,
          scrollElementRef: undefined,
          houseStates: subFocusResult.houseStates,
          rowsCoords: [],
          keyboardUP: false,
        },
      };
      setInitialState(state);
      console.log('state:', state);
      setLoading(false);
    } catch (err) {
      const token = localStorage.getItem('@Portal:token');
      if (token) {
        message.error('Erro ao carregar o jogo, tente novamente mais tarde.');
        // router.back();
        // AQUI A ROTA DEVE VOLTAR PARA O INICIO
      }
    }
  };

  useEffect(() => {
    initializeGame();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      ></div>
    );
  }

  return (
    <GameContextProvider INITIAL_STATE={INITIAL_STATE}>
      <Base
        direct={direct}
        gameDetail={gameDetail}
        size={size}
        sizeHeight={sizeHeight}
      />
    </GameContextProvider>
  );
};
